import { QueryFunctionContext } from '@tanstack/react-query';
import { baseQuery } from '../baseQuery';
import { TechnicianServiceAreaData } from 'types';

type getTechnicianServiceAreasParams = {
  technicianId?: string;
};

export const getTechnicianServiceAreas = async ({
  queryKey,
}: QueryFunctionContext<[string, getTechnicianServiceAreasParams]>): Promise<TechnicianServiceAreaData> => {
  const [, params] = queryKey;
  const { data } = await baseQuery(`technicians/${params.technicianId}/service-areas`);

  return data as TechnicianServiceAreaData;
};
